import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey40, sans, lineHeight, fontSize14 } from "@churchofjesuschrist/eden-style-constants";
export const InternalUseOnlyLegend = styled.legend.withConfig({
  componentId: "sc-1ysb13t-0"
})(["border:none;padding:0;color:", ";font:normal normal normal ", " / ", " ", ";"], grey40, fontSize14, lineHeight, sans);

/**
 * The Legend represents a caption for the content of its parent Fieldset component.
 */
const Legend = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(InternalUseOnlyLegend, props, children);
};
Legend.propTypes = {
  /** Content to render inside the Legend Component */
  children: PropTypes.node.isRequired
};
export default Legend;